import { forwardRef } from 'react';
import { formatRank } from '../../systems/leaderboard';
import { PlayerAvatar } from './player-avatar';
import styles from './leaderboard-row.module.css';

interface LeaderboardRowProps {
  rank: number | null;
  pseudo: string;
  color: string;
  value: string;
  /** La ligne du joueur, surlignée au sable. */
  highlighted?: boolean;
}

/** Une ligne de la liste du classement (rang, avatar, pseudo, valeur). */
export const LeaderboardRow = forwardRef<HTMLLIElement, LeaderboardRowProps>(function LeaderboardRow(
  { rank, pseudo, color, value, highlighted },
  ref,
) {
  const formatted = rank ? formatRank(rank) : null;
  return (
    <li ref={ref} className={`${styles.row}${highlighted ? ` ${styles.mine}` : ''}`} aria-current={highlighted ? 'true' : undefined}>
      <span className={styles.rank}>
        {formatted ? (
          <>
            {formatted.number}
            <sup>{formatted.suffix}</sup>
          </>
        ) : (
          '–'
        )}
      </span>
      <PlayerAvatar pseudo={pseudo} color={color} size={34} />
      <span className={styles.name}>
        {pseudo}
        {highlighted && <span className={styles.srOnly}> (vous)</span>}
      </span>
      <span className={styles.value}>{value}</span>
    </li>
  );
});
